export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_05.1bbab682.jpg";